import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgDownload02 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 21H3m15-10-6 6m0 0-6-6m6 6V3"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgDownload02)
export default ForwardRef
